import { LinearProgress, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import dp from "../assets/dp.jpg";
import { FaCamera } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../component/InputField";
import ButtonCompo from "../component/ButtonCompo";
import AlertBox from "../component/AlertBox";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../constant";
import axios from "axios";
import { reloadToggle } from "../store/reload.slice";

function EmpoloyeeOnboardingForm() {
  // file hooks
  const [upiQrCode, setUpiQrCode] = useState(undefined);
  const [profileImage, setProfileImage] = useState(undefined);
  const [tenth, settenth] = useState(undefined);
  const [twelvth, settwelvth] = useState(undefined);
  const [gradCert, setgradCert] = useState(undefined);
  const [postGardCert, setpostGardCert] = useState(undefined);
  const [diplomaCert, setdiplomaCert] = useState(undefined);
  const [panCard, setpanCard] = useState(undefined);
  const [aadharCard, setaadharCard] = useState(undefined);
  const [bankDetails, setbankDetails] = useState(undefined);
  const [prevOfferLet, setprevOfferLet] = useState(undefined);
  const [prevHikeLet, setprevHikeLet] = useState(undefined);
  const [prevExpLet, setprevExpLet] = useState(undefined);
  const [prevPayslips, setprevPayslips] = useState(undefined);
  const [prevRelivLet, setprevRelivLet] = useState(undefined);
  const [cv, setcv] = useState(undefined);
  const [profileImageUrl, setProfileImageUrl] = useState(undefined);
  // text hooks
  const [email, setEmail] = useState("");
  const [streetAddress, setstreetAddress] = useState("");
  const [state, setstate] = useState("");
  const [city, setcity] = useState("");
  const [country, setcountry] = useState("");
  const [highestEdu, sethighestEdu] = useState("");
  const [skills, setskills] = useState("");
  const [seconderySkills, setseconderySkills] = useState("");
  const [experience, setexperience] = useState("");
  const [password, setPassword] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankAcNo, setBankAcNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [upiId, setUpiId] = useState("");
  // file refs
  const qrCodeRef = useRef(null);
  const profileImageRef = useRef(null);
  const tenThRef = useRef(null);
  const twelvthRef = useRef(null);
  const gardCertRef = useRef(null);
  const postGradCertRef = useRef(null);
  const diplomaCertRef = useRef(null);
  const panCardRef = useRef(null);
  const aadharCardRef = useRef(null);
  const bankDetailsRef = useRef(null);
  const prevOffLetterRef = useRef(null);
  const prevHikeLetRef = useRef(null);
  const prevExpLetRef = useRef(null);
  const prevPayslipsRef = useRef(null);
  const prevRelivRef = useRef(null);
  const cvRef = useRef(null);
  // others
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );

  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  async function updateData(event) {
    event.preventDefault();
    const formData = new FormData();

    if (
      !aadharCard ||
      !bankDetails ||
      !tenth ||
      !twelvth ||
      !gradCert ||
      !profileImage ||
      !cv ||
      !upiQrCode
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select all files which are marked *");
      return null;
    }
    formData.append("bankName", bankName);
    formData.append("bankAcNo", bankAcNo);
    formData.append("panNo", panNo);
    formData.append("gmail", email);
    formData.append("address", streetAddress);
    formData.append("password", password);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("country", country);
    formData.append("experience", experience);
    formData.append("skills", skills);
    formData.append("seconderySkills", seconderySkills);
    formData.append("highestEdu", highestEdu);
    formData.append("upiId", upiId);
    // files
    formData.append("upiQrCode", upiQrCode);
    formData.append("tenThCert", tenth);
    formData.append("twelevThCert", twelvth);
    formData.append("gradCert", gradCert);
    if (postGardCert) {
      formData.append("postGradCert", postGardCert);
    }
    if (diplomaCert) {
      formData.append("diplomaCert", diplomaCert);
    }
    if (panCard) {
      formData.append("panCard", panCard);
    }
    formData.append("aadharCard", aadharCard);
    formData.append("bankDetails", bankDetails);
    if (prevOfferLet) {
      formData.append("prevOfferLetter", prevOfferLet);
    }
    if (prevHikeLet) {
      formData.append("prevHikeLetter", prevHikeLet);
    }
    if (prevExpLet) {
      formData.append("prevExpLetter", prevExpLet);
    }
    if (prevPayslips) {
      formData.append("prevPayslips", prevPayslips);
    }
    if (prevRelivLet) {
      formData.append("prevRelivingLetter", prevRelivLet);
    }
    formData.append("logo", profileImage);
    formData.append("cv", cv);

    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/update`,
        method: "post",
        data: formData,
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data", // Axios automatically sets this
        },
      });
      dispatch(reloadToggle());
      //dispatch(employeeLogin({status: true}))
      navigate("/employee/dashboard");
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full flex flex-col justify-center items-center">
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      {success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={message}
        />
      )}
      {!success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={message}
        />
      )}
      <div className="w-[90vw] flex flex-col justify-center items-center py-5">
        <h2 className="text-[30px] font-bold">
          Hi {employeeData?.fullName?.split(" ")[0]}, Welcome to{" "}
          {employeeData?.company?.companyName}
        </h2>
        <p className="text-[17px] font-medium text-slate-500">
          Please fill the onboarding form given below
        </p>
        <div className="w-full mt-5">
          <div className="w-full flex flex-col justify-center items-center">
            <section className="w-[8rem] h-[8rem] relative">
              <input
                type="file"
                className="hidden"
                onChange={(e) => {
                  setProfileImage(e?.target?.files[0]);
                  setProfileImageUrl(URL.createObjectURL(e?.target?.files[0]));
                }}
                ref={profileImageRef}
              />
              <img
                src={profileImageUrl || dp}
                className="w-full h-full object-cover rounded-full"
                alt=""
              />
              <section className="bg-sky-500 absolute bottom-3 left-[80%] p-2 rounded-full">
                <FaCamera
                  className="text-[20px] text-white cursor-pointer"
                  onClick={() => profileImageRef.current.click()}
                />
              </section>
            </section>
            {!profileImage && (
              <p className="mt-3 text-[15px] text-red-500">
                *Add A profile picture
              </p>
            )}
          </div>
          <div></div>
        </div>
        <div className="w-full mt-5">
          <div className="w-full">
            <form onSubmit={updateData} className="w-full">
              <h3 className="mb-3 text-[17px] font-medium text-slate-600">
                Personal Details
              </h3>
              <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5">
                <InputField
                  label="Bank Name"
                  required
                  onChange={(e) => setBankName(e?.target?.value)}
                />
                <InputField
                  label="Bank A/C Number"
                  required
                  onChange={(e) => setBankAcNo(e?.target?.value)}
                />
                <InputField
                  label="UPI ID"
                  required
                  onChange={(e) => setUpiId(e?.target?.value)}
                />
                <InputField
                  label="PAN Number"
                  required
                  onChange={(e) => setPanNo(e?.target?.value)}
                />
                <InputField
                  label="Street Address"
                  required
                  onChange={(e) => setstreetAddress(e?.target?.value)}
                />
                <InputField
                  label="City"
                  required
                  onChange={(e) => setcity(e?.target?.value)}
                />
                <InputField
                  label="State"
                  required
                  onChange={(e) => setstate(e?.target?.value)}
                />
                <InputField
                  label="Country"
                  required
                  onChange={(e) => setcountry(e?.target?.value)}
                />
                <InputField
                  label="New Password"
                  required
                  onChange={(e) => setPassword(e?.target?.value)}
                />
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={aadharCardRef}
                    onChange={(e) => setaadharCard(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">Aadhar Card(PDF)*</p>
                    <p className="text-slate-600 text-[12px]">
                      {aadharCard !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => aadharCardRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={panCardRef}
                    onChange={(e) => setpanCard(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">PAN Card(Both side-PDF)</p>
                    <p className="text-slate-600 text-[12px]">
                      {panCard !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => panCardRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={bankDetailsRef}
                    onChange={(e) => setbankDetails(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">Bank Details(PDF)*</p>
                    <p className="text-slate-600 text-[12px]">
                      {bankDetails !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => bankDetailsRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={qrCodeRef}
                    onChange={(e) => setUpiQrCode(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">UPI QR Code*</p>
                    <p className="text-slate-600 text-[12px]">
                      {upiQrCode !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => qrCodeRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
              </div>
              <h3 className="mb-3 mt-10 text-[17px] font-medium text-slate-600">
                Educational Details
              </h3>
              <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5">
                <InputField
                  label="Highest Education"
                  required
                  onChange={(e) => sethighestEdu(e?.target?.value)}
                />
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={tenThRef}
                    onChange={(e) => settenth(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">
                      10th Pass Certificate(PDF)*
                    </p>
                    <p className="text-slate-600 text-[12px]">
                      {tenth !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => tenThRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={twelvthRef}
                    onChange={(e) => settwelvth(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">
                      12th Pass Certificate(PDF)*
                    </p>
                    <p className="text-slate-600 text-[12px]">
                      {twelvth !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => twelvthRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={gardCertRef}
                    onChange={(e) => setgradCert(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">
                      Graduation Certificate(PDF)*
                    </p>
                    <p className="text-slate-600 text-[12px]">
                      {gradCert !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => gardCertRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={postGradCertRef}
                    onChange={(e) => setpostGardCert(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600 truncate">
                      PG Certificate(PDF)
                    </p>
                    <p className="text-slate-600 text-[12px]">
                      {postGardCert !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => postGradCertRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={diplomaCertRef}
                    onChange={(e) => setdiplomaCert(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">Diploma Certificate(PDF)</p>
                    <p className="text-slate-600 text-[12px]">
                      {diplomaCert !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => diplomaCertRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
              </div>
              <h3 className="mb-3 mt-10 text-[17px] font-medium text-slate-600">
                Professional Details
              </h3>
              <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5">
                <InputField
                  label="Experience(in years)"
                  required
                  onChange={(e) => setexperience(e?.target?.value)}
                />
                <InputField
                  label="Skills"
                  required
                  onChange={(e) => setskills(e?.target?.value)}
                />
                <InputField
                  label="Secondery Skills"
                  required
                  onChange={(e) => setseconderySkills(e?.target?.value)}
                />
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={prevOffLetterRef}
                    onChange={(e) => setprevOfferLet(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">Previous Offer Letter(PDF)</p>
                    <p className="text-slate-600 text-[12px]">
                      {prevOfferLet !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => prevOffLetterRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={prevHikeLetRef}
                    onChange={(e) => setprevHikeLet(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">Previous Hike Letter(PDF)</p>
                    <p className="text-slate-600 text-[12px]">
                      {prevHikeLet !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => prevHikeLetRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={prevExpLetRef}
                    onChange={(e) => setprevExpLet(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">Experience Letter(PDF)</p>
                    <p className="text-slate-600 text-[12px]">
                      {prevExpLet !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => prevExpLetRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={prevPayslipsRef}
                    onChange={(e) => setprevPayslips(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600 truncate">
                      Last 3 months Payslips(PDF)
                    </p>
                    <p className="text-slate-600 text-[12px]">
                      {prevPayslips !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => prevPayslipsRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={prevRelivRef}
                    onChange={(e) => setprevRelivLet(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">
                      Previous Reliving Letter(PDF)
                    </p>
                    <p className="text-slate-600 text-[12px]">
                      {prevRelivLet !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => prevRelivRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
                <section className="flex w-full items-center justify-between h-[1.4375em] border-[1.5px] rounded-[4px] border-slate-300 px-[14px] py-[28px]">
                  <input
                    type="file"
                    className="hidden"
                    ref={cvRef}
                    onChange={(e) => setcv(e?.target?.files[0])}
                  />
                  <div className="w-full">
                    <p className="text-slate-600">CV(PDF)*</p>
                    <p className="text-slate-600 text-[12px]">
                      {cv !== undefined ? "1" : "No"} file selected
                    </p>
                  </div>
                  <ButtonCompo onClick={() => cvRef.current.click()}>
                    Upload
                  </ButtonCompo>
                </section>
              </div>
              <div className="flex w-full justify-end items-end mt-10">
                <ButtonCompo variant="contained" type="submit">
                  Save & Continue
                </ButtonCompo>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmpoloyeeOnboardingForm;
